// extracted by mini-css-extract-plugin
module.exports = {"constructor":"constructor__-lbJ+UJ9afnra","result":"result__9wAuPrbqTBQaa","letterSettings":"letterSettings__sEJVls1nhoCI4"};